/**
 * Generates the booking title based on business requirements
 *
 * @param {Object} booking - The booking object
 * @param {Object} bookingType - The booking type object with title property
 * @param {bool} showConfidentialDetails - Whether to show personal information
 * @returns {string} The formatted booking title
 */
export function generateBookingTitle(booking, bookingType, showConfidentialDetails) {

	// If booking has a custom title, and it's not empty, use it
	if (booking.title && booking.title.trim()) {
		return booking.title;
	}
	// If confidential information is to be shown, show owner of booking, if available
	else if (showConfidentialDetails) {
		let personInfo = "";
		if (booking.employee) {
			personInfo = booking.employee.displayName || '';
			if (booking.employee.shortCode) {
				personInfo += ` (${booking.employee.shortCode})`;
			}
		} else if (booking.student) {
			personInfo = booking.student.displayName || '';
			if (booking.student.shortCode) {
				personInfo += ` (${booking.student.shortCode})`;
			}
		}
		if (personInfo) {
			return personInfo;
		}
	}
	
	// Otherwise, show booking type title
	return bookingType?.title || 'Buchung';
}
